"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@emotion/react");
var _react2 = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("../Box"));
var _Header = _interopRequireDefault(require("../Header"));
var _Html = _interopRequireDefault(require("../Html"));
var _Image = _interopRequireDefault(require("../Image"));
var _Link = _interopRequireDefault(require("../Link"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _Text = _interopRequireDefault(require("../Text"));
var _NoticeAttachmentBlock = _interopRequireDefault(require("./privateComponents/NoticeAttachmentBlock"));
var _NoticeAttachmentList = _interopRequireDefault(require("./privateComponents/NoticeAttachmentList"));
var _NoticeMetaInfo = _interopRequireDefault(require("./privateComponents/NoticeMetaInfo"));
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NoticeCard = ({
  notice,
  isModal,
  attachmentsRef,
  imageSrc,
  showAllContent,
  onAttachmentDownload,
  onEventDownload,
  onModalClose,
  variant = 'portal',
  createdByRole = 'board'
}) => {
  const [open, setOpen] = (0, _react2.useState)(!!showAllContent);
  const theme = (0, _react.useTheme)();
  const Content = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    hasImage: !!imageSrc,
    children: [imageSrc && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
        src: imageSrc,
        alt: "Oppslag bilde"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContentWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {
        level: 4,
        color: theme.secondaryDarkText,
        id: "noticeModalTitle",
        children: notice.title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Div, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoticeMetaInfo.default, {
          created: notice.createdDate,
          updated: notice.updatedDate,
          createdBy: notice.createdBy,
          variant: variant,
          createdByRole: createdByRole
        })
      }), notice.bodyHtml && notice.bodyHtml.length <= 2000 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Div, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Html.default, {
          whiteSpace: "normal",
          text: notice.bodyHtml,
          externalLinks: true
        })
      }), notice.bodyHtml && notice.bodyHtml.length > 2000 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Div, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Html.default, {
            whiteSpace: "normal",
            externalLinks: true,
            text: open ? notice.bodyHtml : notice.bodyHtml.substring(0, 2000)
          })
        }), !showAllContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Div, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
            onClick: () => setOpen(!open),
            children: open ? 'Vis mindre' : 'Les mer'
          })
        })]
      }), notice.eventStart && notice.eventEnd && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Div, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          bold: true,
          children: "Hendelse"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoticeAttachmentBlock.default, {
          type: "cal",
          name: `${notice.eventTitle ? notice.eventTitle : notice.title}${notice.eventLocation ? '\nSted: ' + notice.eventLocation : ''}`,
          description: (0, _utils.getNoticeMeetingDescription)(notice.eventStart, notice.eventEnd),
          onDownload: onEventDownload
        })]
      }), notice.attachments && notice.attachments.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Div, {
        ref: attachmentsRef,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          bold: true,
          children: "Vedlegg"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoticeAttachmentList.default, {
          attachments: notice.attachments,
          onDownload: onAttachmentDownload && onAttachmentDownload
        })]
      })]
    })]
  });
  return isModal ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, {
    "aria-labelledby": "noticeModalTitle",
    width: imageSrc ? '920px' : '720px',
    open: true,
    onClose: onModalClose,
    children: Content
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    type: "mysite",
    children: Content
  });
};
var _default = exports.default = NoticeCard;